'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector, shallowEqual } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PreviewScreenshot from '../PreviewScreenshot';
import OverallResultSection from '../result/OverallResultSection';
import { CTA_OVERALL_BANNER_LINK } from '../../constants/TrialConstants';
import { getDesktopPreview } from '../../selectors/Preview';
import { LanguageCTALinks } from '../../constants/TrialConstants';
import { parseUtmParams } from '../../util/Urls';
import usageTracker from '../../lib/usageTracker';
import styled from 'styled-components';

var getLangKey = function getLangKey() {
  return window.I18N_MANUAL_LANG;
}; // do not remove before WSG widget results page v2 or widget will break.


var Gradient = styled.div.withConfig({
  displayName: "OverallPage__Gradient",
  componentId: "isou4i-0"
})(["background:", ";position:absolute;height:600px;top:0;width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return theme.resultsPage.overallResults.background;
});

var LangButton = function LangButton(_ref2) {
  var websiteUrl = _ref2.websiteUrl;
  var lang = getLangKey();
  var parsedUtmParams = parseUtmParams();
  var isEn = lang === 'en';

  var handleClick = function handleClick() {
    var eventKey = isEn ? 'academyCourseClick' : 'freeGuideClick';
    var action = isEn ? 'clicked-start-free-course-button' : 'clicked-get-guide-button';
    usageTracker.log(eventKey, {
      action: action,
      websiteUrl: websiteUrl,
      source: 'results-header'
    });
  };

  if (!isEn) {
    return /*#__PURE__*/_jsx("a", {
      className: "button lg",
      href: LanguageCTALinks[lang] + "&" + parsedUtmParams,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trialBanner.ctaButtonGetGuide"
      })
    });
  }

  return /*#__PURE__*/_jsx("a", {
    className: "button lg",
    href: CTA_OVERALL_BANNER_LINK + "&" + parsedUtmParams,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trialBanner.ctaButtonCourse"
    })
  });
};

export default (function (_ref3) {
  var websiteGrade = _ref3.websiteGrade,
      _ref3$hideCTAs = _ref3.hideCTAs,
      hideCTAs = _ref3$hideCTAs === void 0 ? false : _ref3$hideCTAs;

  var _useSelector = useSelector(getDesktopPreview, shallowEqual),
      url = _useSelector.url,
      error = _useSelector.error;

  var domain = websiteGrade.domain;
  return /*#__PURE__*/_jsx("div", {
    className: "full-page-centered overall-page",
    id: "overall",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx(Gradient, {
          className: "bg-gradient"
        }), /*#__PURE__*/_jsx(OverallResultSection, {
          websiteGrade: websiteGrade
        }), !hideCTAs && /*#__PURE__*/_jsx(LangButton, {
          websiteUrl: domain
        }), /*#__PURE__*/_jsx(PreviewScreenshot, {
          previewUrl: url,
          error: error
        })]
      })
    })
  });
});